import Swiper from "swiper/bundle";

export const QuizResults = async () => {
  const $quizResults = document.querySelector("section.quiz-results");

  const formatPrice = (number) => {
    let GBP = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    });

    const firstString = GBP.format(number);

    const secondString = firstString.replace("GBP ", "£");

    return secondString;
  };

  if ($quizResults) {
    const asideContainer = document.querySelector(".cart-aside__background");
    const $cartAside = document.querySelector(".cart-aside");

    const openCartAside = () => {
      const target = document.querySelector(".cart-aside");
      $cartAside.style.transform = "translateX(0%)";
      asideContainer.style.pointerEvents = "auto";
      asideContainer.style.opacity = "100%";
      $cartAside.style.pointerEvents = "auto";
      target.classList.add("is-active");
    };

    const $quizResultsContents = $quizResults.querySelector(
      ".quiz-results__contents"
    );

    const $contentsRecomended = $quizResultsContents.querySelectorAll(
      ".contents__recomended"
    );
    const $contentsOther =
      $quizResultsContents.querySelector(".contents__other");

    const $otherProductsDesktop = $contentsOther.querySelector(
      ".other__products.other__products--desktop"
    );
    const $otherProductsDesktopItems =
      $otherProductsDesktop.querySelectorAll(".other__product");

    const $otherProductsMobile = $contentsOther.querySelector(
      ".other__products.other__products--mobile"
    );
    const $otherProductsMobileItems =
      $otherProductsMobile.querySelectorAll(".other__product");
    const $productsSwiper =
      $otherProductsMobile.querySelector(".products__swiper");

    let coffee_quiz_answers = null;
    if (localStorage.getItem("coffee_quiz_answers")) {
      coffee_quiz_answers = JSON.parse(
        localStorage.getItem("coffee_quiz_answers")
      );

      // if (coffee_quiz_answers.time + 86400 >= Date.now()) {
      //     window.location = "/pages/coffee-quiz";
      // } else {
      // const product_blocks = coffee_quiz_answers.product_blocks;
      const sections = coffee_quiz_answers.sections;
      // const answers = coffee_quiz_answers.answers;

      let othersCount = 0;
      sections.forEach((section) => {
        if (
          section.name === "Upsell / All" ||
          section.id === "a4ce8ef8c24a44a2e6ed221a27bbe559aac826bb"
        ) {
          section.products.forEach((product) => {
            $otherProductsDesktopItems.forEach(($otherProduct) => {
              if (
                parseInt($otherProduct.dataset.productId) ===
                  parseInt(product.id) ||
                $otherProduct.dataset.variantIds.includes(product.id)
              ) {
                othersCount = othersCount + 1;

                $otherProduct.classList.add("other__product--active");
              }
            });

            $otherProductsMobileItems.forEach(($otherProduct) => {
              if (
                parseInt($otherProduct.dataset.productId) ===
                  parseInt(product.id) ||
                $otherProduct.dataset.variantIds.includes(product.id)
              ) {
                $otherProduct.classList.add("other__product--active");
              }
            });
          });
        } else {
          section.products.forEach((product) => {
            $contentsRecomended.forEach(($contentsRecomendedItem) => {
              if (
                parseInt($contentsRecomendedItem.dataset.productId) ===
                  parseInt(product.id) ||
                $contentsRecomendedItem.dataset.variantIds.includes(product.id)
              ) {
                $contentsRecomendedItem.classList.add(
                  "contents__recomended--active"
                );
                const $infoDescription =
                  $contentsRecomendedItem.querySelector(".info__description");
                $infoDescription.innerHTML = product.description;
              }
            });
          });
        }
      });

      if (othersCount == 0) {
        $contentsOther.classList.add("contents__other--hidden");
      }

      const setUpFunctionality = ($infoElement) => {
        const $infoPrice = $infoElement.querySelector(".info__price");
        // const $infoControls =
        //     $infoElement.querySelector(".info__controls");

        const $optionContainers =
          $infoElement.querySelectorAll(".option__container");

        const $optionsSelects = $infoElement.querySelectorAll(
          ".controls__options .option__select"
        );

        const $variantsSelect = $infoElement.querySelector(
          ".controls__variants .variants__select"
        );

        const $controlsPurchaseTypes = $infoElement.querySelector(
          ".controls__purchase-types"
        );

        const $purchaseTypeOneTime = $controlsPurchaseTypes.querySelector(
          ".purchase-type.purchase-type--one-time"
        );
        const $purchaseTypeSubscribe = $controlsPurchaseTypes.querySelector(
          ".purchase-type.purchase-type--subscribe"
        );

        const $controlsSellingPlans = $infoElement.querySelector(
          ".controls__selling-plans"
        );
        const $sellingPlansSelect = $controlsSellingPlans?.querySelector(
          ".selling-plans__container .container__select"
        );

        const $controlsButtons =
          $infoElement.querySelector(".controls__buttons");
        const $buttonCart = $controlsButtons.querySelector(
          ".controls__button--cart"
        );
        const $buttonCartPrice = $buttonCart?.querySelector(".button__price");
        const $buttonViewDetails = $controlsButtons.querySelector(
          ".controls__button--details"
        );

        const $buttonQuantityValue =
          $controlsButtons?.querySelector(".quantity__value");
        const $buttonQuantityIncrease = $controlsButtons?.querySelector(
          ".quantity__buttons .quantity__up"
        );
        const $buttonQuantityDecrease = $controlsButtons?.querySelector(
          ".quantity__buttons .quantity__down"
        );

        const updatePrices = () => {
          if (
            $purchaseTypeSubscribe &&
            $purchaseTypeSubscribe.classList.contains(
              "purchase-type--active"
            ) &&
            $sellingPlansSelect
          ) {
            const sellingPlanAllocations =
              $variantsSelect.options[$variantsSelect.selectedIndex].dataset
                .sellingPlanAllocations;
            const plansJson = JSON.parse(sellingPlanAllocations);

            const activePlan = plansJson[0];

            const quantity = $buttonQuantityValue
              ? parseInt($buttonQuantityValue.dataset.value)
              : 1;

            const formattedPrice = formatPrice(
              (parseInt(activePlan.price) * quantity) / 100
            );
            if ($infoPrice) {
              $infoPrice.innerText = formattedPrice;
            }

            if ($buttonCartPrice) {
              $buttonCartPrice.innerText = formattedPrice;
            }
          } else {
            const price =
              $variantsSelect.options[$variantsSelect.selectedIndex].dataset
                .variantPrice;

            const quantity = $buttonQuantityValue
              ? parseInt($buttonQuantityValue.dataset.value)
              : 1;
            const formattedPrice = formatPrice(
              (parseInt(price) * quantity) / 100
            );
            if ($infoPrice) {
              $infoPrice.innerText = formattedPrice;
            }
            if ($buttonCartPrice) {
              $buttonCartPrice.innerText = formattedPrice;
            }
          }
        };

        $purchaseTypeOneTime?.addEventListener("click", (event) => {
          event.preventDefault();
          $purchaseTypeOneTime.classList.add("purchase-type--active");

          if ($infoElement.classList.contains("recomended__info")) {
            $infoElement.classList.remove("recomended__info--subscribe");
          } else {
            $infoElement.classList.remove("product-info--subscribe");
          }

          if ($purchaseTypeSubscribe) {
            $purchaseTypeSubscribe.classList.remove("purchase-type--active");
          }

          const price =
            $variantsSelect.options[$variantsSelect.selectedIndex].dataset
              .variantPrice;

          const quantity = $buttonQuantityValue
            ? parseInt($buttonQuantityValue.dataset.value)
            : 1;
          const formattedPrice = formatPrice(
            (parseInt(price) * quantity) / 100
          );

          if ($infoPrice) {
            $infoPrice.innerText = formattedPrice;
          }

          if ($buttonCartPrice) {
            $buttonCartPrice.innerText = formattedPrice;
          }
        });

        $purchaseTypeSubscribe?.addEventListener("click", (event) => {
          event.preventDefault();

          if ($purchaseTypeOneTime) {
            $purchaseTypeOneTime.classList.remove("purchase-type--active");
          }

          if ($infoElement.classList.contains("recomended__info")) {
            $infoElement.classList.add("recomended__info--subscribe");
          } else {
            $infoElement.classList.add("product-info--subscribe");
          }

          $purchaseTypeSubscribe.classList.add("purchase-type--active");
          const sellingPlanAllocations =
            $variantsSelect.options[$variantsSelect.selectedIndex].dataset
              .sellingPlanAllocations;
          const plansJson = JSON.parse(sellingPlanAllocations);
          const activePlan = plansJson[0];

          const quantity = $buttonQuantityValue
            ? parseInt($buttonQuantityValue.dataset.value)
            : 1;

          const formattedPrice = formatPrice(
            (parseInt(activePlan.price) * quantity) / 100
          );
          if ($infoPrice) {
            $infoPrice.innerText = formattedPrice;
          }

          if ($buttonCartPrice) {
            $buttonCartPrice.innerText = formattedPrice;
          }
        });

        if ($buttonQuantityIncrease && $buttonQuantityValue) {
          $buttonQuantityIncrease.addEventListener("click", (event) => {
            event.preventDefault();
            const value = parseInt($buttonQuantityValue.dataset.value) + 1;
            $buttonQuantityValue.innerText = value;
            $buttonQuantityValue.dataset.value = value;
            updatePrices();
          });
        }

        if ($buttonQuantityDecrease && $buttonQuantityValue) {
          $buttonQuantityDecrease.addEventListener("click", (event) => {
            event.preventDefault();
            const value = parseInt($buttonQuantityValue.dataset.value) - 1;
            $buttonQuantityValue.innerText = value > 0 ? value : 1;
            $buttonQuantityValue.dataset.value = value > 0 ? value : 1;
            updatePrices();
          });
        }

        $optionsSelects?.forEach(($optionsSelect) => {
          $optionsSelect.addEventListener("change", (event) => {
            event.preventDefault();

            const $changedSelect = $optionsSelect;

            const getOptionsString = () => {
              const optionsArray = [];
              $optionsSelects.forEach(($optionsSelectInner) => {
                optionsArray.push($optionsSelectInner.value);
              });
              const optionsString = optionsArray.join("-");
              return optionsString;
            };

            const findVariant = (optionString) => {
              let foundVaraint = null;
              for (let i = 0; i < $variantsSelect.options.length; i++) {
                if (
                  $variantsSelect.options[i].dataset.variantHandle ===
                  optionString
                ) {
                  foundVaraint = $variantsSelect.options[i].value;
                  break;
                }
              }

              return foundVaraint;
            };

            const foundVaraint = findVariant(getOptionsString());
            if (foundVaraint === null) {
              let searchVariant = null;
              for (let i = $optionsSelects.length - 1; i >= 0; i--) {
                if ($optionsSelects[i] == $changedSelect) {
                  continue;
                } else {
                  for (let c = 0; c < $optionsSelects[i].options.length; c++) {
                    $optionsSelects[i].value =
                      $optionsSelects[i].options[c].value;
                    searchVariant = findVariant(getOptionsString());
                    if (searchVariant !== null) {
                      break;
                    }
                  }
                  if (searchVariant !== null) {
                    break;
                  }
                }
              }

              $variantsSelect.value = searchVariant;
            } else {
              $variantsSelect.value = foundVaraint;
            }

            $optionContainers.forEach(($optionContainer) => {
              const $optionButtons = $optionContainer.querySelectorAll(
                ".option__buttons .option__button"
              );
              const $optionsSelect =
                $optionContainer.querySelector(".option__select");

              $optionButtons.forEach(($optionButton) => {
                if ($optionButton.dataset.optionValue == $optionsSelect.value) {
                  $optionButton.classList.add("option__button--selected");
                } else {
                  $optionButton.classList.remove("option__button--selected");
                }
              });
            });
            updatePrices();
          });
        });

        $optionContainers.forEach(($optionContainer) => {
          const $optionButtons = $optionContainer.querySelectorAll(
            ".option__buttons .option__button"
          );
          const $optionsSelect =
            $optionContainer.querySelector(".option__select");

          $optionButtons.forEach(($optionButton) => {
            $optionButton.addEventListener("click", (event) => {
              event.preventDefault();
              $optionButtons.forEach(($optionButtonInner) => {
                if ($optionButtonInner == $optionButton) {
                  $optionButtonInner.classList.add("option__button--selected");
                  $optionsSelect.value = $optionButtonInner.dataset.optionValue;
                  $optionsSelect.dispatchEvent(new Event("change"));
                } else {
                  $optionButtonInner.classList.remove(
                    "option__button--selected"
                  );
                }
              });
            });
          });
        });

        $variantsSelect.addEventListener("change", (event) => {
          event.preventDefault();

          const variantOptions =
            $variantsSelect.options[$variantsSelect.selectedIndex].dataset
              .variantOptions;
          const optionsJson = JSON.parse(variantOptions);
          optionsJson.forEach((optionString, index) => {
            $optionsSelects[index].value = optionString;
          });
          $optionContainers.forEach(($optionContainer) => {
            const $optionButtons = $optionContainer.querySelectorAll(
              ".option__buttons .option__button"
            );
            const $optionsSelect =
              $optionContainer.querySelector(".option__select");

            $optionButtons.forEach(($optionButton) => {
              if ($optionButton.dataset.optionValue == $optionsSelect.value) {
                $optionButton.classList.add("option__button--selected");
              } else {
                $optionButton.classList.remove("option__button--selected");
              }
            });
          });
          updatePrices();
        });

        $buttonCart.addEventListener("click", (event) => {
          event.preventDefault();

          let sellingPlanId = null;
          if (
            $purchaseTypeSubscribe &&
            $purchaseTypeSubscribe.classList.contains(
              "purchase-type--active"
            ) &&
            $sellingPlansSelect
          ) {
            // const sellingPlanAllocations =
            //     $variantsSelect.options[
            //         $variantsSelect.selectedIndex
            //     ].dataset.sellingPlanAllocations;
            // const plansJson = JSON.parse(sellingPlanAllocations);
            // const activePlan = plansJson[0];
            sellingPlanId = $sellingPlansSelect.value;
          }

          const Cart = window.Carbon.Cart;
          const quantity = $buttonQuantityValue
            ? parseInt($buttonQuantityValue.dataset.value)
            : 1;
          Cart.addItemToCart($variantsSelect.value, quantity, sellingPlanId);
          openCartAside();
        });

        $buttonViewDetails?.addEventListener("click", (event) => {
          event.preventDefault();
          if ($infoElement.classList.contains("recomended__info")) {
            $infoElement.classList.add("recomended__info--details");
          } else {
            $infoElement.classList.add("product-info--details");
          }
        });
      };

      $contentsRecomended.forEach(($contentsRecomendedItem) => {
        if (
          $contentsRecomendedItem.classList.contains(
            "contents__recomended--active"
          )
        ) {
          const $recomendedInfo =
            $contentsRecomendedItem.querySelector(".recomended__info");
          setUpFunctionality($recomendedInfo);
        }
      });

      $otherProductsDesktopItems.forEach(($otherProduct) => {
        if ($otherProduct.classList.contains("product__info--active")) {
          const $productInfo = $otherProduct.querySelector(".product__info");

          setUpFunctionality($productInfo);
        }
      });

      $otherProductsMobileItems.forEach(($otherProduct) => {
        if ($otherProduct.classList.contains("product__info--active")) {
          const $productInfo = $otherProduct.querySelector(".product__info");

          setUpFunctionality($productInfo);
        }
      });

      if ($productsSwiper) {
        const swiperConfig = {
          direction: "horizontal",
          speed: 1000,
          slidesPerView: 1.2,
          slidesPerGroup: 1,
          spaceBetween: 12,
          centeredSlides: false,
        };

        const swiperObject = new Swiper($productsSwiper, swiperConfig);
      }

      // }
    } else {
      window.location = "/pages/coffee-quiz";
    }
  }
};

export default QuizResults;
